"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var theme_1 = require("../theme"); // tslint:disable-line:no-deep-relative-imports
require("svgxuse/svgxuse"); // polyfill for IE 11
var IconBase = /** @class */ (function (_super) {
    tslib_1.__extends(IconBase, _super);
    function IconBase(props) {
        return _super.call(this, props) || this;
    }
    IconBase.prototype.render = function () {
        var _a = this.props, className = _a.className, _b = _a.name, name = _b === void 0 ? 'matchLogo' : _b, theme = _a.theme;
        var iconSprite = (typeof theme.components.icon.url === 'function')
            ? theme.components.icon.url()
            : theme.components.icon.url;
        var prefix = theme.components.icon.prefix || '';
        return (react_1.default.createElement("span", { className: className },
            react_1.default.createElement("svg", { viewBox: "0 0 24 24" },
                react_1.default.createElement("use", { xlinkHref: iconSprite + "#" + prefix + name }))));
    };
    return IconBase;
}(react_1.default.PureComponent));
exports.default = theme_1.withTheme(IconBase);
